exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-sheet.v-toolbar[data-v-73da35e8]:not(.v-sheet--outlined){box-shadow:none;border-bottom:1px solid #e4cdc0}.v-sheet.v-list[data-v-73da35e8]:not(.v-sheet--outlined){border-top:2px solid #e4cdc0}.v-toolbar__title[data-v-73da35e8]{font-family:Dancing Script;color:#8a736d;font-size:1.5rem}", ""]);

// exports
